(function () {
  function addBusinessDays(start, days) {
    var date = new Date(start.getTime());
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return date;
  }

  function formatDate(date) {
    return date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function parseLeadRange(text) {
    if (!text) return null;
    var normalized = text.toLowerCase();
    var range = normalized.match(/(\d+)\s*[–\-—to]+\s*(\d+)\s*(business\s*)?day/);
    if (range) return { min: parseInt(range[1], 10), max: parseInt(range[2], 10) };
    var single = normalized.match(/(\d+)\s*(business\s*)?day/);
    if (single) {
      var n = parseInt(single[1], 10);
      return { min: n, max: n };
    }
    return null;
  }

  function readDropshipRange(slot) {
    if (!slot || slot.getAttribute('data-tcb-dropship') !== 'true') return null;
    var procMin = parseInt(slot.getAttribute('data-tcb-processing-min') || '1', 10);
    var procMax = parseInt(slot.getAttribute('data-tcb-processing-max') || '3', 10);
    var transitMin = parseInt(slot.getAttribute('data-tcb-transit-min') || '7', 10);
    var transitMax = parseInt(slot.getAttribute('data-tcb-transit-max') || '21', 10);
    return {
      min: procMin + transitMin,
      max: procMax + transitMax,
      dropship: true
    };
  }

  function resolveRange(slot) {
    var lead = slot.getAttribute('data-tcb-lead-time') || '';
    var parsed = parseLeadRange(lead);
    if (parsed) return parsed;

    var dual = lead.toLowerCase().match(/(\d+)\s*[–\-—to]+\s*(\d+)[\s\S]*?(\d+)\s*[–\-—to]+\s*(\d+)/);
    if (dual) {
      return {
        min: parseInt(dual[1], 10) + parseInt(dual[3], 10),
        max: parseInt(dual[2], 10) + parseInt(dual[4], 10)
      };
    }

    return readDropshipRange(slot);
  }

  function escapeHtml(value) {
    if (window.TcbSecurity && window.TcbSecurity.escapeHtml) {
      return window.TcbSecurity.escapeHtml(value);
    }
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildEstimate(slot) {
    var lead = slot.getAttribute('data-tcb-lead-time') || '';
    var note = slot.getAttribute('data-tcb-freight-note') || 'Estimated delivery can change based on inventory, freight carrier, destination, and liftgate or appointment requirements.';
    var range = resolveRange(slot);
    var etaLine = lead;

    if (range) {
      var minDate = addBusinessDays(new Date(), range.min);
      var maxDate = addBusinessDays(new Date(), range.max);
      etaLine = range.min === range.max
        ? 'Order today — estimated delivery ' + formatDate(minDate)
        : 'Order today — estimated delivery ' + formatDate(minDate) + ' – ' + formatDate(maxDate);
    }

    return (
      '<div class="tcb-eta-fallback tcb-eta-card tcb-eta-card--estimated">' +
        '<strong>Delivery Date / ETA</strong>' +
        '<span data-tcb-eta-value>' + escapeHtml(etaLine) + '</span>' +
        '<small>' + escapeHtml(note) + '</small>' +
      '</div>'
    );
  }

  function hasAppWidget(slot) {
    return slot.querySelector(
      '.deliverydate.sb_delivery, .sb_delivery, .tcb-eta-app-blocks .shopify-app-block, [id*="delivery-date-eta"], [class*="estimated-delivery"]'
    );
  }

  function renderEstimate() {
    var slot = document.getElementById('tcb-delivery-app-slot');
    if (!slot || hasAppWidget(slot)) return;
    if (slot.querySelector('.tcb-eta-app-blocks .shopify-app-block')) return;
    if (slot.querySelector('[data-tcb-eta-value]')) return;

    var mount = slot.querySelector('.tcb-eta-app-mount');
    var blocks = slot.querySelector('.tcb-eta-app-blocks');
    var html = buildEstimate(slot);
    if (mount) {
      mount.innerHTML = html;
    } else {
      slot.innerHTML = html;
      if (blocks) slot.prepend(blocks);
    }
    slot.classList.add('tcb-eta-card', 'tcb-app-slot--filled', 'tcb-app-slot--estimated');
  }

  function boot() {
    renderEstimate();
    [800, 2200, 5000].forEach(function (ms) {
      setTimeout(renderEstimate, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('tcb:variant-change', function () {
    setTimeout(renderEstimate, 200);
  });
})();
